import { h, Component } from "preact";
import styles from "./MoodSelector.scss";
import icons from "../../../../assets/icons";

export default class MoodSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: this.props.selected,
    };
  }

  onMoodClicked(value) {
    if (value == this.state.selected) {
      value = null;
    }
    this.setState({ selected: value });
    this.props.onChanged(value);
  }

  render() {
    const { selected } = this.state;
    const moods = icons.map((icon, index) => (
      <img
        key={index + 1}
        src={icon}
        className={selected == index + 1 ? styles.moodSelected : styles.mood}
        onClick={() => this.onMoodClicked(index + 1)}
      />
    ));
    return <div className={styles.container}>{moods}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/modules/diary/components/moodSelector/MoodSelector.js